import React, {useState} from 'react';
import '../style/comments.css'

export default function Comments(props) {
  const [comments, setComments] = useState([
    {pseudo: 'Manu', avatar: 'avatar_Manu.png', date: '08/04/2024 à 12h15', message: 'Your show is great, we had a lot of fun!'},
    {pseudo: 'Rose', avatar: 'avatar_Rose.png', date: '16/04/2024 à 18h30', message: 'Thank you, we hope to see you again in our city. Best wishes'},
    {pseudo: 'Aliss', avatar: 'avatar_Aliss.png', date: '08/04/2024 à 12h15', message: 'Damn, you missed me, when are you coming back?'},
    {pseudo: 'Jo', avatar: 'avatar_Jo.png', date: '08/04/2024 à 12h15', message: 'We had a good laugh, come back soon!'},
  ]);
  const [commentForm, setCommentForm] = useState({
    disp: false,
    email: '',
    pseudo: '',
    comment: '',
  });
  const buildComment = () => {

  };
  return (
    <div style={{borderTop: '1px solid lightgrey', paddingTop: '10px', margin: '0 50px'}}>
      <div className="comment_header">
        <h2>Comments page</h2>
        <div style={{paddingLeft: '10vw'}}>
          <img
            className="add_comment"
            onClick={() => setCommentForm({...commentForm, disp: true})}
            src={process.env.PUBLIC_URL + '/icons/add_comment_70x70.ico'}
            width="50"
            height="50"
            alt="add comment" />
        </div>
      </div>
      <div className="comments_container">
        {comments.map((com, index) => (
            <ul className="one_comment" key={'comment' + index}>
              <li style={{textAlign: 'left'}}>
                <img
                  className="comment_avatar"
                  src={process.env.PUBLIC_URL + '/avatars/' + com.avatar}
                  alt={'avatar' + com.pseudo} />
                <span className="comment_identity">
                  <span style={{fontSize: '20px', fontWeight: '700'}}>{com.pseudo}</span>
                  <span style={{fontSize: '12px', paddingLeft: '12px'}}>{com.date}</span>
                </span>
              </li>
              <li style={{fontSize: '18px', position: 'relative', top: '-20px'}}>{com.message}</li>
            </ul>
        ))}
      </div>
      {commentForm.disp && (
        <div className="comment_form_container">
          <div className="comment_form_content">
            <div
                className="hideCommentForm"
                onClick={() => {
                  document.querySelector('.comment_form_content').style.animation = 'hide_comment_form 0.4s linear';
                  setTimeout(() => setCommentForm({
                    disp: false,
                    email: '',
                    pseudo: '',
                    comment: '',}),
                    400);
                  }}>
                <img
                  className="add_comment"
                  src={process.env.PUBLIC_URL + '/icons/go_back_70x70.ico'}
                  width="50"
                  height="50"
                  alt="go back" />
            </div>
            <div className="comment_form">
              <h4>Add your comment</h4>
              <div className="comment_div">
                <label>Your pseudo?</label>
                <input

                type="text"
                className="comment_text_input"
                size="20"
                maxLength="20"
                value={commentForm.pseudo}
                onChange={(e) => setCommentForm({...commentForm, pseudo: e.target.value})} />
              </div>
              <hr style={{width: '260px', color: 'white'}}></hr>
              <div className="comment_div">
                <label>Your email?</label>
                <input
                  type="email"
                  size="20"
                  maxLength="80"
                  className="comment_text_input"
                  value={commentForm.email}
                  onChange={(e) => setCommentForm({...commentForm, email: e.target.value})} />
              </div>
              <hr style={{width: '260px', color: 'white'}}></hr>
              <div className="comment_div" style={{height: '10vh'}}>
                <label style={{color: 'grey'}}>Avatar?</label>
                <span style={{color: 'red'}}>Unavailable on this demo version</span>
                <input type="file" disabled/>
              </div>
              <hr style={{width: '260px', color: 'white'}}></hr>
              <div className="comment_textarea_div">
                <label>Your comment?</label>
                <textarea
                  className="comment_textarea"
                  rows="8"
                  cols="26"
                  maxLength="200"
                  value={commentForm.comment}
                  onChange={(e) => setCommentForm({...commentForm, comment: e.target.value})}></textarea>
              </div>
              <hr style={{width: '260px', color: 'white'}}></hr>
              <div className="comment_but_div">
                  <button
                    className="reservation_buts"
                    style={{'--reservation_buts_bg': 'transparent'}}>
                    <img
                      className="add_comment"
                      src={process.env.PUBLIC_URL + '/icons/go_back_70x70.ico'}
                      width="50"
                      height="50"
                      alt="go back" 
                      onClick={() => {
                        document.querySelector('.comment_form_content').style.animation = 'hide_comment_form 0.4s linear';
                        setTimeout(() => setCommentForm({
                          disp: false,
                          email: '',
                          pseudo: '',
                          comment: '',}),
                          400);
                      }}/>
                  </button>
                  <button
                    className="reservation_buts"
                    style={{'--reservation_buts_bg': '#5BD845'}}
                    onClick={() => {
                        document.querySelector('.comment_form_content').style.animation = 'hide_comment_form 0.4s linear';
                        setTimeout(() => setCommentForm({
                          disp: true,
                          email: '',
                          pseudo: '',
                          comment: 'In the real version, the comment will be published after agreement with the moderator.',}),
                          400);
                      }}>
                    VALIDATE
                  </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
